import SkyeHoverBox from './SkyeHoverBox.js';

/* This JSON object holds the content for the Hover Boxes in the Business Page
The message1 key holds the content before Hovering
The message2 key hold the content that appears after hovering. */

var businessBenefits =  {
	0: {
		message1: '<span>Increased Employee Satisfaction</span>',
		message2: '<span>68% of workers say training and development is the most important workplace policy. <span class="sup-script">1</span></span>',
		ariaText: 'Box 1) Increased Employee Satisfaction.'
	},
	1: {
		message1: '<span>Increased Employee Retention</span>',
		message2: '<span>95% of hiring managers consider employee training as a key retention tool. <span class="sup-script">2</span></span>',
		ariaText: 'Box 2) Increased Employee Retention.'
	},
	2: {
		message1: '<span>Increased Employee Engagement and Productivity</span>',
		message2: '<span>Companies with engaged employees outperform those without by over 200%. <span class="sup-script">3</span></span>',
		ariaText: 'Box 3) Increased Employee Engagement and Productivity.'
	},
	3: {
		message1: '<span>Increased Company Profitability and Stability</span>',
		message2: '<span>Companies that provide employees with comprehensive training have 218% higher income per employee than those that do not provide training. <span class="sup-script">4</span></span>',
		ariaText: 'Box 4) Increased Company Profitability and Stability.'
	}
};

/* Hoverbox Block Node */
let hoverBoxBlockNode = document.querySelector('.hoverbox-block');

/* Instantiation for the Hover Box using the businessBenefits object */
    var hoverbox = new SkyeHoverBox(businessBenefits);
	hoverbox.ActivateHoverBoxes();
